export function formatCurrency(value) {
    if (isNaN(value)) return value;
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function unformatCurrency(value) {
    return value.replace(/\D/g, '') / 100;
}